import { getAllNotes } from '@/api/note.js';
const noteTemplate = {
  namespaced: true,
  state: {
    noteTemplateList : [],
  },
  mutations: {
    SET_ALL_NOTES(state, allNotes) {
      state.noteTemplateList = allNotes;
    },

    // always set the created note to the first for notes in dialog
    SET_NEW_NOTE_TEMPLATE(state, newNote) {
      state.noteTemplateList.unshift(newNote);
    },

    // always place the updated note to the first for notes in dialog
    UPDATE_NOTE_TEMPLATE(state, note) {
      let foundNote = state.noteTemplateList.find(o => o.noteid === note.noteid);
      foundNote.name = note.name;
      foundNote.content = note.content;
      foundNote.modifieddate = note.modifieddate;
      let index = state.noteTemplateList.indexOf(foundNote);
      state.noteTemplateList.splice(index,1);
      state.noteTemplateList.unshift(foundNote);
    },

    DELETE_NOTE_TEMPLATE(state, deleteNoteId) {
      let foundItem = state.noteTemplateList.find(item => item.noteid === deleteNoteId);
      let index = state.noteTemplateList.indexOf(foundItem);
      if (index > -1) {
        state.noteTemplateList.splice(index,1);
      }
    },
  },
  actions: {
    // sort all notes by most recent date after get
    async setAllNotes({ commit }) {
      let { data } = await getAllNotes();
      let allNotes = data.sort(
        (a, b) => new Date(b.modifieddate) - new Date(a.modifieddate)
      );
      commit("SET_ALL_NOTES", allNotes);
    },
    setNewNoteTemplate({ commit }, newNote) {
      commit("SET_NEW_NOTE_TEMPLATE", newNote);
    },
    updateNewNoteTemplate({ commit }, note) {
      commit("UPDATE_NOTE_TEMPLATE", note);
    },
    deleteNoteTemplate({ commit }, deleteNoteId) {
      commit("DELETE_NOTE_TEMPLATE", deleteNoteId);
    },
  }
};

export default noteTemplate;